{
    "frames": {
        "noJoinSelected": {
            "frame": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "none": {
            "frame": { "x": 384, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "houseWall": {
            "frame": { "x": 768, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "parapetWall": {
            "frame": { "x": 1152, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "gutterDrip": {
            "frame": { "x": 1536, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "raisedKerb": {
            "frame": { "x": 1920, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "pitchRoofOn": {
            "frame": { "x": 2304, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "pitchRoofOff": {
            "frame": { "x": 2688, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "feltJoin": {
            "frame": { "x": 3072, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "seamJoin": {
            "frame": { "x": 3456, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        },
        "buttJoin": {
            "frame": { "x": 3840, "y": 0, "w": 384, "h": 384 },
            "spriteSourceSize": { "x": 0, "y": 0, "w": 384, "h": 384 },
            "sourceSize": { "w": 384, "h": 384 },
            "anchor": { "x": 0, "y": 0 }
        }
    },

    "meta": {
        "image": "isometric-named.jpg",
        "format": "RGBA8888",
        "size": { "w": 4224, "h": 384 },
        "scale": 1
    }
}